import { Connector, useAccount, useConnect, useDisconnect } from "wagmi";
import metamaskIcon from "../../assets/images/metamask.png";

import walletconnectIcon from "../../assets/images/walletconnect.png";
import closeIcon from "../../assets/images/close.svg";
import arrowRight from "../../assets/images/arrowRight.svg";
import styles from "./index.module.scss";
import { useModalStore } from "@/store/modle";
import { useDataStore, WalletSource } from "@/store/dataStore";
import { Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import coinbase from "@/assets/images/coinbase.png";
import rabby from "@/assets/images/rabby.png";
import { useWeb3Context } from "../providers/Web3ContextProvider";
import { CacheAddress } from "@/constants/const";
// import rainbow from "@/assets/images/rainbow.png";
// import CutCornerBox from "../CutConterBox";

type Provider = {
  logo: any;
  name: string;
};
interface ProviderProps {
  provider: Provider;
  onClick: () => void;
}
export default function ProviderModal(): JSX.Element {
  const { connectAsync, connectors, reset } = useConnect();
  const { disconnect } = useDisconnect();
  const { getAuth } = useWeb3Context();
  const [loading, setLoading] = useState(false);
  const [onConnect, setOnConnect] = useState(false);
  const showProviderModal = useModalStore((state) => state.showProviderModal);
  const { setShowProviderModal } = useModalStore((state) => state);
  const isMobile = useDataStore((state) => state.isMobile);
  const { setWalletSource } = useDataStore((state) => state);
  const { connector } = useAccount();
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const handleSelectProvider = async (
    connectorNew: any,
    walletName?: string
  ) => {
    // if (
    //   walletName === "Coinbase Wallet" &&
    //   !(window as any)?.coinbaseWalletExtension
    // ) {
    //   window.open(
    //     "https://chromewebstore.google.com/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
    //     "_blank"
    //   );
    //   return;
    // }
    if (walletName === "Rabby" && !(window as any)?.rabby) {
      window.open(
        "https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch",
        "_blank"
      );
      return;
    }
    if (walletName === "Rainbow" && !(window as any)?.rainbow) {
      window.open(
        "https://chromewebstore.google.com/detail/rainbow/opfgelmcmbiajamepnmloijbpoleiama",
        "_blank"
      );
      return;
    }
    setLoading(true);
    localStorage.setItem("auth", "");
    localStorage.setItem(CacheAddress.cacheAddress, "");

    try {
      reset();
      await disconnect();
      await new Promise((resolve) => setTimeout(resolve, 500));
      const res = await connectAsync({ connector: connectorNew });
      setOnConnect(true);
      if (connectorNew.name !== "WalletConnect") {
        const res2 = await connectorNew?.getAccounts();

        if (res2) {
          // await getAuth(res2[0]);
          localStorage.setItem(CacheAddress.cacheAddress, res2[0]);
          setLoading(false);
          setShowProviderModal(false);
        }
      }
    } catch (error) {
      disconnect();
      localStorage.setItem(CacheAddress.cacheAddress, "");
      setLoading(false);
    }
  };
  const setAuth = async () => {
    if (!connector) {
      return;
    }
    let authStr;
    authStr = localStorage.getItem(CacheAddress.cacheAddress);
    if (connector.name === "WalletConnect" && !authStr && onConnect) {
      const res = await connector?.getProvider();
      const connectorInfo = res as any;
      const isSafe =
        connectorInfo?.session?.peer?.metadata?.name.indexOf("Safe") > -1;
      // await getAuth(connectorInfo?.accounts[0], isSafe, connectorInfo.chainId);
      localStorage.setItem(
        CacheAddress.cacheAddress,
        connectorInfo?.accounts[0]
      );
      setOnConnect(false);
      setLoading(false);
      setShowProviderModal(false);
    }
  };
  useEffect(() => {
    setAuth();
  }, [connector, onConnect]);

  const Provider = (props: ProviderProps) => {
    const { provider, onClick } = props;
    return (
      <div className={styles.provider} onClick={onClick}>
        <div className={styles.providerLeft}>
          <img
            src={props.provider.logo}
            width={isMobile ? 28 : 42}
            alt="circle"
          />
          <div className={styles.providerText}>{provider.name}</div>
        </div>
        <img src={arrowRight} width={24} alt="circle" />
      </div>
    );
  };
  const deduplication = (arr: any) => {
    const res = new Map();
    return arr.filter(
      (item: Connector) =>
        !res.has(JSON.stringify(item.name)) &&
        res.set(JSON.stringify(item.name), 1)
    );
  };

  const deduplicatWallets = deduplication(connectors) as Connector[];

  let filterWallets = deduplicatWallets.filter(
    (connector) =>
      connector.name === "Injected" ||
      connector.name === "WalletConnect" ||
      connector.name === "Coinbase Wallet"
  );
  const injectedConnector = filterWallets.find(
    (connector) => connector.name === "Injected"
  );
  const filterNoWallets = deduplicatWallets.filter(
    (connector) =>
      connector.name !== "Injected" &&
      connector.name !== "WalletConnect" &&
      connector.name !== "Coinbase Wallet"
  );
  if (filterNoWallets.length === 0) {
    filterWallets = filterWallets.filter(
      (connector) =>
        connector.name === "WalletConnect" ||
        connector.name === "Coinbase Wallet"
    );
  }
  return (
    <Modal
      title="Connect Your Wallet"
      className={styles.providerModal}
      width={410}
      open={showProviderModal}
      centered={true}
      onCancel={() => {
        setShowProviderModal(false);
      }}
      // centered
      footer={null}
      closeIcon={<img src={closeIcon} alt="close" />}
    >
      <div className={styles.content}>
        <Spin spinning={loading} className={styles.customSpin}>
          <div className={styles.providerList}>
            {filterNoWallets.length === 0 && (
              <Provider
                provider={{ logo: metamaskIcon, name: "MetaMask" }}
                onClick={() => {
                  window.open(
                    "https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
                    "_Blank"
                  );
                }}
              />
            )}
            {filterWallets.map((connector, index) => {
              if (connector.name === "Injected") {
                return (
                  <Provider
                    key={index}
                    provider={{ logo: metamaskIcon, name: "MetaMask" }}
                    onClick={() => {
                      setWalletSource(WalletSource.FromWeb);
                      handleSelectProvider(connector);
                    }}
                  />
                );
              } else if (connector.name === "WalletConnect") {
                return (
                  <Provider
                    key={index}
                    provider={{ logo: walletconnectIcon, name: connector.name }}
                    onClick={() => {
                      setWalletSource(WalletSource.FromMobile);
                      handleSelectProvider(connector);
                    }}
                  />
                );
              } else if (connector.name === "Coinbase Wallet") {
                return (
                  <Provider
                    key={index}
                    provider={{ logo: coinbase, name: connector.name }}
                    onClick={() => {
                      setWalletSource(WalletSource.FromWeb);
                      handleSelectProvider(connector, "Coinbase Wallet");
                    }}
                  />
                );
              }
            })}
            <Provider
              provider={{ logo: rabby, name: "Rabby" }}
              onClick={() => {
                setWalletSource(WalletSource.FromWeb);
                handleSelectProvider(injectedConnector, "Rabby");
              }}
            />
            {/* <Provider
              provider={{ logo: rainbow, name: "Rainbow" }}
              onClick={() => {
                setWalletSource(WalletSource.FromWeb);
                handleSelectProvider(injectedConnector, "Rainbow");
              }}
            /> */}
          </div>
        </Spin>

        {/* <div className={styles.providerFooter}></div> */}
      </div>
    </Modal>
  );
}
